import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { LazyImportWrapper } from 'components/foundation/LazyImportWrapper/LazyImportWrapper';
import { useOpenable } from 'hooks';
import useProjectPlanningIsEnabled from 'hooks/feature/project-planning/useProjectPlanningIsEnabled/useProjectPlanningIsEnabled';
import { t } from 'i18next';
import React from 'react';
import { ClassName } from 'types/ClassName';
import IPosition from 'types/Position';

const ManageProjectPlanForm = React.lazy(() => import('../forms/ManageProjectPlanForm'));

export const POSITION_MANAGE_PROJECT_PLAN_DETAIL_TITLE = t('Manage Project Plans');
export const POSITION_MANAGE_PROJECT_PLAN_DETAIL_DESCRIPTION = t(`View, edit, delete, and create project plans.`);

export interface IManageProjectPlanDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

function ManageProjectPlanDetail(props: IManageProjectPlanDetailProps) {
  const { position, onUpdate, editable, className } = props;
  const positionValue = !!position.manageResourcePlanning;
  const isProjectPlanningEnabled = useProjectPlanningIsEnabled();
  const dialog = useOpenable();

  if (!isProjectPlanningEnabled) {
    return null;
  }

  function onSubmit() {
    dialog.close();
    onUpdate();
  }

  const classes = classNames('manage-project-plan', className);

  return (
    <>
      <ProDetailsItem
        title={POSITION_MANAGE_PROJECT_PLAN_DETAIL_TITLE}
        onClick={dialog.open}
        value={positionValue ? t('Yes') : t('No')}
        hint={POSITION_MANAGE_PROJECT_PLAN_DETAIL_DESCRIPTION}
        className={classes}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={dialog.isOpen} onClose={dialog.close}>
        <LazyImportWrapper triggerLoad={dialog.isOpen}>
          <ManageProjectPlanForm
            className="mt-4 p-8"
            onSubmit={onSubmit}
            position={position}
          />
        </LazyImportWrapper>
      </Dialog>
    </>
  );
}

export default ManageProjectPlanDetail;
